import React, { useState } from 'react';
import { backupDatabase } from '../services/api';

const BackupDati = () => {
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ type: '', text: '' });

  const handleBackupDatabase = async () => {
    setLoading(true);
    setMessage({ type: '', text: '' });
    try {
      const response = await backupDatabase();
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      const date = new Date().toISOString().slice(0, 10);
      link.setAttribute('download', `database_backup_${date}.backup`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      setMessage({ type: 'success', text: 'Backup database scaricato con successo!' });
    } catch (err) {
      setMessage({ type: 'error', text: `Errore: ${err.response?.data?.detail || err.message}` });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: '2rem', maxWidth: 600 }}>
      <h2>Backup Database</h2>
      <p style={{ color: '#555', marginBottom: '1.5rem' }}>
        Scarica un dump completo del database PostgreSQL (<code>.backup</code>).
        Il codice è già su Git, le immagini sono in locale — solo il database necessita di backup manuale.
      </p>

      <button
        onClick={handleBackupDatabase}
        disabled={loading}
        style={{
          padding: '0.75rem 1.5rem',
          background: loading ? '#aaa' : '#1976d2',
          color: '#fff',
          border: 'none',
          borderRadius: 6,
          cursor: loading ? 'not-allowed' : 'pointer',
          fontSize: '1rem',
        }}
      >
        {loading ? 'Backup in corso...' : '⬇ Scarica Backup Database'}
      </button>

      {message.text && (
        <p style={{ marginTop: '1rem', color: message.type === 'success' ? 'green' : 'red' }}>
          {message.text}
        </p>
      )}
    </div>
  );
};

export default BackupDati;
